<script setup>
</script>

<template>
  <div class="d-none">
    <slot/>
  </div>
  <div class="vh-100 d-flex justify-content-center align-items-center">
    <span class="spinner-border"/>
  </div>
</template>